<svg width="389" height="389" viewBox="0 0 389 389" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M388.953 240.249V0H0V369.078L307.988 169.584L190.333 316.368C174.525 336.418 172.951 356.184 182.156 376.692L388.953 240.249Z" fill="white"/>
<path d="M388.953 240.249V388.953H309.147C304.512 383.914 302.806 377.5 302.478 371.478C301.953 361.835 305.167 352.366 310.962 344.621L388.953 240.249Z" fill="white"/>
</svg>
